export default __webpack_public_path__ + "static/media/dune_pilat_forest.4ccb504f.jpg";